var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-alert",
    {
      staticClass: "layout-license-alert",
      class: _vm.showLicenseAlert ? "visible" : "",
      attrs: { value: _vm.showLicenseAlert, type: _vm.licenseAlertType }
    },
    [
      _c("div", [
        _c("b", [_vm._v("Attention Required!")]),
        _vm._v(" Your license is scheduled to expire on\n    "),
        _c("span", [_vm._v(_vm._s(_vm.licenseExpirationDate))]),
        _vm._v(
          ". Please contact your account executive to discuss renewal options.\n  "
        )
      ]),
      _vm._v(" "),
      _c("v-btn", { attrs: { small: "" }, on: { click: _vm.hideAlert } }, [
        _vm._v("Remind me later")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }